import React from 'react';
import classnames from 'classnames';
import styles from './styles.module.css';

const SectionTitle = ({
    title, subTitle, center=true
}) => (
    <div className={classnames(styles.main, center ? styles.center : undefined)}>
        {
            title && title != '' ? (
                <div className={styles.sectionTitle}>
                    {title}
                </div>
            ) : null
        }
        {
            subTitle && subTitle != '' ? (
                <div className={styles.sectionSubtitle}>
                    {subTitle}
                </div>
            ) : null
        }
    </div>
);

export default SectionTitle;